import { useFormik } from 'formik';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom
import * as Yup from 'yup'; // Import Yup
import BreadCrumbs from '../components/BreadCrumbs';
import { callPostWebservice } from '../hooks/api';

// Validation Schema using Yup
const validationSchema = Yup.object({
	email: Yup.string()
		.email('Invalid email address')
		.required('Email is required')
});

const Forgot = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();

	// Forgot

	const formik = useFormik({
		initialValues: {
			email: '',
		},
		validationSchema,
		onSubmit: (values, { setSubmitting }) => {

			const requestPacket = {
				email: values.email,
			};

			callPostWebservice('forgot', requestPacket, (response) => {
				alert(response.message);
			}, (error) => {
				setSubmitting(false);

				let err = {
					email: error.errMessage
				}
				formik.setErrors(err);

			});
		},
	});

	return (
		<>

			<BreadCrumbs title1={'Home'} title2={'Pages'} title3={'Login'} />

			{/* <!-- ======================= Login Detail ======================== --> */}
			<section className="middle">
				<div className="container">
				<div className="row align-items-center justify-content-center">

						<div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
							<div className="text-center mb-4">
								<h2 className="m-0 ft-regular">Forgot Password</h2>
								<br/>
								<p>Lost your password? Please enter your email address. You will receive a link to create a new password via email.</p>
								
							</div>
		

							<form className="border p-3 rounded" onSubmit={formik.handleSubmit}>
								<div className="form-group">
									<label>Email *</label>
									<input
										type="text"
										name="email"
										className="form-control"
										placeholder="Email*"
										value={formik.values.email}
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
									/>
									{formik.touched.email && formik.errors.email ? (
										<div className="text-danger">{formik.errors.email}</div>
									) : null}
								</div>

								<div className="form-group">
									<button
										type="submit"
										className="btn btn-md full-width bg-dark text-light fs-md ft-medium"
										disabled={formik.isSubmitting || !formik.isValid}  // Disable if form is not valid or submitting

									>
										Forgot
									</button>
								</div>
							</form>
						</div>

					</div>
				</div>
			</section>
			{/* <!-- ======================= Login End ======================== --> */}
		</>
	)
}

export default Forgot